import api from '../utils/api';
import AddressDetails from '../model/AddressDetails';
import Constants from '../constants';
import DispatchConstants from '../constants/DispatchConstants';
import { logError } from '@zg-rentals/log-error';

// service

const AddressActions = {
  getRentZestimate(fullAddress, unit) {
    return (dispatch) =>
      dispatch(api.properties.address.rentZestimate(fullAddress, unit)).then((response) => {
        if (response.success && response.response) {
          return response.response;
        }
        return Promise.reject(response.error);
      });
  },
  getDetails(addressData) {
    return (dispatch) =>
      dispatch(api.properties.address.details(addressData))
        .then((response) => {
          const { error: errorRMWModel, success, response: getDetailsResponse } = response;
          if (success && getDetailsResponse) {
            const { status, message } = getDetailsResponse;
            if (status && status.toLowerCase() === Constants.ADDRESS_STATUS_FAILURE.toLowerCase()) {
              return Promise.reject(message);
            }
            const addressDetailsModel = AddressDetails(getDetailsResponse);

            dispatch({
              type: DispatchConstants.ADDRESS_DETAILS,
              payload: addressDetailsModel,
            });

            return addressDetailsModel;
          }
          return Promise.reject(errorRMWModel);
        })
        .catch((errorRMWModel) => {
          logError({
            error: errorRMWModel,
            context: 'AddressActions.getDetails',
          });

          return Promise.reject(errorRMWModel);
        });
  },
  verify(addressData) {
    return (dispatch) =>
      dispatch(
        api.properties.address.verification({
          address: addressData.address,
          unit: addressData.unit,
          propertyTypeCode: addressData.propertyTypeCode,
        }),
      ).then((response) => {
        if (response.success && response.response) {
          return response.response;
        }
        return Promise.reject(response.error);
      });
  },
  getRestrictions(addressData) {
    const { address, unit, listingTypeCode, listingAlias, propertyTypeCode } = addressData;
    return (dispatch) =>
      dispatch(
        api.properties.locations.getRestrictions({
          address,
          unit,
          listingTypeCode,
          listingAlias,
          propertyTypeCode,
        }),
      )
        .then((response) => {
          const { error: errorRMWModel, success } = response;

          if (success && response.response) {
            return response.response;
          }
          return Promise.reject(errorRMWModel);
        })
        .catch((errorRMWModel) => {
          logError({
            error: errorRMWModel,
            context: 'AddressActions.getRestrictions',
          });
          return Promise.reject(errorRMWModel);
        });
  },
  getPublicRestrictions(addressData) {
    const { address, unit, listingTypeCode, listingAlias, propertyTypeCode } = addressData;
    return (dispatch) =>
      dispatch(
        api.properties.locations.getPublicRestrictions({
          address,
          unit,
          listingTypeCode,
          listingAlias,
          propertyTypeCode,
        }),
      )
        .then((response) => {
          const { error: errorRMWModel, success } = response;

          if (success && response.response) {
            return response.response;
          }
          return Promise.reject(errorRMWModel);
        })
        .catch((errorRMWModel) => {
          logError({
            error: errorRMWModel,
            context: 'AddressActions.getPublicRestrictions',
          });
          return Promise.reject(errorRMWModel);
        });
  },
};

export default AddressActions;
